export const PERM_PLANNING_EDIT = 'PLANNING.EDIT'
export const PERM_PLANNING_INDISPO = 'PLANNING.INDISPO'
export const PERM_PLANNING_EDIT_SHORT_PERIOD = 'PLANNING.EDIT_SHORT_PERIOD'
export const PERM_LOG = 'PLANNING.LOG'
